import React from 'react';
import {CheckboxProps} from 'antd';
import {StyledCheckbox} from './styles';

export const CustomCheckbox: React.FC<CheckboxProps> = ({...props}) => <StyledCheckbox {...props} />;
